import React, { Component } from 'react';
import { Row, Col } from 'reactstrap';
import '../../pages/dashboard/Analytics.css';
import '../../components/Pagination/Pagination.css';

class Pagination extends Component {
  render() {
    const { currentPage , totalPageNumber, handlePageNavigation, Analytics, generatePageNumbers, handleRecordCountChange, recordCount, totalRecords } = this.props;
    return (
        <div>
            <Row className="mt-4 mb-3">
                <Col className="text-left"><span className="showpageCount">{`Total records (including removed or deleted items) :  ${totalRecords}`}</span></Col>
                <Col className="text-center"> <span className="showpageCount">{`Showing Page ${currentPage} Of ${totalPageNumber === 0 ? 1 : totalPageNumber}`}</span></Col>
                <Col className="text-right">
                
                        <select className="selectscrol" onChange={handleRecordCountChange} value={recordCount}>
                            <option value="10">10 rows</option>
                            <option value="20">20 rows</option>
                            <option value="30">30 rows</option>
                            <option value="40">40 rows</option>
                            <option value="50">50 rows</option>
                        </select>
                </Col>           
            </Row>

            <Row className="pagination">
                <nav aria-label="Page navigation example" className="text-center">
                        <ul className="pagination">
                        <li className="page-item previousBtnArrow" className = {currentPage <= 1 ? 'disabledLiElement' : null }><span className="page-link previousBtnArrow" onClick= {() => handlePageNavigation('previous')}></span></li>
                            <li className="page-item previousBtn" className = {currentPage <= 1 ? 'disabledLiElement' : null }><span className="page-link" onClick= {() => handlePageNavigation('previous')}>Previous</span></li>
                            
                            { generatePageNumbers(Analytics) }

                            <li className="page-item nextBtn" className = {currentPage >= totalPageNumber ? 'disabledLiElement' : null }><span className="page-link" onClick={() => handlePageNavigation('next')}>Next</span></li>
                            <li className="page-item nextBtnArrow" className = {currentPage >= totalPageNumber ? 'disabledLiElement' : null }><span className="page-link nextBtnArrow" onClick={() => handlePageNavigation('next')}></span></li>

                        </ul>
                </nav>             
            </Row>
        </div>
    )
  }
}

export default Pagination;